module.exports = __webpack_public_path__ + "318a4c4031c15def30302fe41b2c3893.svg";